import { createClient } from '@supabase/supabase-js'
import { SUPABASE_ANON_KEY, SUPABASE_URL } from './env'

export const supabase = createClient(SUPABASE_URL || 'https://placeholder.supabase.co', SUPABASE_ANON_KEY || 'placeholder', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
  },
})

/**
 * Normalizes a Postgres/PostgREST error (raised via `RAISE EXCEPTION` in an
 * RPC function) into a stable code + human detail. Every RPC in this app
 * raises a short machine-readable MESSAGE ('duplicate_mobile',
 * 'stale_write', ...) and, where useful, a JSON-encoded DETAIL -- see the
 * comment at the top of supabase/migrations/..._guest_writes_and_admin_rpc.sql.
 */
export function parseRpcError(error: unknown): { code: string; detail: string | null; raw: unknown } {
  const e = error as { message?: string; details?: string; hint?: string } | null
  const code = e?.message || 'unknown_error'
  const detail: string | null = e?.details ?? null
  return { code, detail, raw: error }
}

export function tryParseJson<T = unknown>(value: string | null): T | null {
  if (!value) return null
  try {
    return JSON.parse(value) as T
  } catch {
    return null
  }
}
